var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilledPost(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 15H19.5C19.2188 15 19 15.25 19 15.5V16H17V15.5C17 14.125 18.0938 13 19.5 13H26.5C27.875 13 29 14.125 29 15.5V22.5C29 23.9062 27.875 25 26.5 25H26V23H26.5C26.75 23 27 22.7812 27 22.5V15.5C27 15.25 26.75 15 26.5 15ZM13 19C13 17.9062 13.875 17 15 17H23C24.0938 17 25 17.9062 25 19V27C25 28.125 24.0938 29 23 29H15C13.875 29 13 28.125 13 27V19ZM16 21H22C22.5312 21 23 20.5625 23 20C23 19.4688 22.5312 19 22 19H16C15.4375 19 15 19.4688 15 20C15 20.5625 15.4375 21 16 21Z",
    fill: "#5F6774"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledPost);
export default __webpack_public_path__ + "static/media/filledPost.ae623cc74ad82aa9287d16b9368cdaff.svg";
export { ForwardRef as ReactComponent };